import MentionsOfficialAccountPostCard from './MentionsOfficialAccountPostCard';

export default MentionsOfficialAccountPostCard;
